// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import InviteYourColleagueFormState from "@store/Framework/Store/Greif/Components/InviteYourColleagueForm/InviteYourColleagueFormState";
import { Draft } from "immer";

const initialState: InviteYourColleagueFormState = {
    fieldValues: {},
};

const actions = {
    "Greif/Components/InviteYourColleagueForm/ClearForm": (draft: Draft<InviteYourColleagueFormState>) => {
        draft.fieldValues = {};
    },
    "Greif/Components/InviteYourColleagueForm/SetFieldValue": (
        draft: Draft<InviteYourColleagueFormState>,
        action: { key: string; value: string | any[] },
    ) => {
        draft.fieldValues[action.key] = action.value;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifComponentsInviteYourColleagueFormActions = Parameters<typeof reducer>[1];
export default reducer;
